export const getNewslettersToSubscribe = (state) =>
  state.selectedOptionsIds.filter(
    (selectedOptionId) =>
      // Selected option is not already subscribed
      !state.dataSubscriptions.list
        .filter((newsletter) => newsletter.isSubscribed)
        .map((newsletter) => newsletter.id)
        .includes(selectedOptionId)
  );
